
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { AlertBoxOptions } from "@/types/controls";

@Component({
  components: { Icon }
})
export default class AlertBox extends Vue {
  @Prop()
  options!: AlertBoxOptions;

  get alertType() {
    if (this.options && this.options.style !== "default") {
      return this.options.style;
    }
    return undefined;
  }

  get alertClass() {
    if (this.options && this.options.style) {
      return this.options.style;
    }
    return "default";
  }

  get content() {
    return this.options && this.options.content ? this.options.content : "";
  }
}
